import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Typography } from "@mui/material";
/**
 * Shared table chrome for the Commission Tracker tabs (Daily Update, Summary).
 * Mirrors the Account Performance table: bordered cells, sticky grouped header,
 * and a bold sticky "Total Summary" footer.
 */
export const commissionTableContainerSx = {
    border: "1px solid #EAECF0",
    borderRadius: "8px",
    overflow: "hidden",
    "& table": { borderCollapse: "separate", borderSpacing: 0 },
    "& th, & td": { borderRight: "1px solid #EAECF0", borderBottom: "1px solid #EAECF0" },
    "& tr > :first-of-type": { borderLeft: "1px solid #EAECF0" },
    "& thead tr:first-of-type th": { borderTop: "1px solid #EAECF0" },
    "& thead th, & thead tr:nth-of-type(1) th, & thead tr:nth-of-type(2) th": { background: "#F9FAFB", position: "sticky", zIndex: 6 },
    "& thead tr:nth-of-type(2) th": { top: "45px", zIndex: 5 },
    "& tbody tr:last-of-type td": { backgroundColor: "#F9FAFB", fontWeight: 700, color: "#101828" },
    "& tfoot td, & tfoot th": { backgroundColor: "#F9FAFB", fontWeight: 700 },
    // ── Sticky first column (Client / Date) ──
    // The grouped header's first column spans both header rows via rowSpan, so it
    // only lives in header row 1 — pin that one (row 2's first cell is a group
    // child and must scroll horizontally). Body + Total-row first cells match.
    // z-index must beat the group-header cells (inline z=11), hence !important.
    "& thead tr:first-of-type th:first-of-type": { position: "sticky", left: 0, zIndex: "13 !important", backgroundColor: "#fff" },
    "& tbody td:first-of-type": { position: "sticky", left: 0, zIndex: 3, backgroundColor: "#fff" },
    "& tbody tr.reusable-table-summary-row td:first-of-type": { zIndex: 4, backgroundColor: "#F9FAFB" },
};
/** Currency text with a muted "$" symbol, matching the reference table. */
export const CurrencyText = React.memo(({ value, bold }) => {
    const isNeg = value < 0;
    const symbolColor = bold ? "#a4a7ae" : "#a1a1aa";
    return (_jsx(Box, { sx: { px: 1, textAlign: "left" }, children: _jsxs(Typography, { sx: {
                fontFamily: "Inter",
                fontWeight: bold ? 600 : 400,
                color: bold ? "#181d27" : "#27272a",
                whiteSpace: "nowrap",
                fontSize: "14px !important",
            }, children: [_jsx("span", { style: { color: symbolColor }, children: "$ " }), isNeg ? "-" : "", Math.abs(Math.round(value)).toLocaleString()] }) }));
});
/** Muted secondary currency line shown beneath a primary value in Summary cells. */
export const SubCurrencyText = React.memo(({ value }) => {
    const isNeg = value < 0;
    return (_jsxs(Typography, { sx: { px: 1, fontFamily: "Inter", fontWeight: 400, color: "#98A2B3", whiteSpace: "nowrap", fontSize: "13px !important" }, children: [_jsx("span", { style: { color: "#cbd0d6" }, children: "$ " }), isNeg ? "-" : "", Math.abs(Math.round(value)).toLocaleString()] }));
});
